import {
  MarsPeriodService
} from "../../../../Services/AddressProgram/AddressProgram.Frontend/services/MarsPeriodService";

const state = {
  marsPeriod: {},
  handler: () => {},
  showPeriodModal: false,
  marsPeriodService: new MarsPeriodService(),
};

const getters = {
  getMarsPeriod: (state) => {
    return state.marsPeriod;
  },
  getPeriodModalState: (state) => {
    return state.showPeriodModal;
  }
};

const mutations = {
  SET_MARSPERIOD: (state, data) => {
    state.marsPeriod = data;
  },
  SET_PERIODMODALSTATE: (state, data) => {
    state.showPeriodModal = data;
  },
  SET_HANDLER: (state, handler) => {
    state.handler = handler;
  },
  HANDLE: (state) => {
    state.handler();
  },
};

const actions = {
  setMarsPeriod(context, period) {
    const local = localStorage.getItem("currentMarsPeriod");
    if (local && !period) {
      context.commit("SET_MARSPERIOD", JSON.parse(local));
    } else if (period) {
      localStorage.setItem("currentMarsPeriod",  JSON.stringify(period));
      context.commit("SET_MARSPERIOD", period);
    }
    // обработчик задается в Application\Frontends\ProSpace\components\BaseLayout.vue
    context.commit("HANDLE");
    context.rootGetters["maapNotifications/notificationMessages"];
  },
  setHandler(context, handler) {
    context.commit("SET_HANDLER", handler);
  },
  async updateCurrentPeriod(context, periodId) {
    if (!periodId) return;
    const params = `$filter=((((id eq ${periodId}))))`;
    try {
      const result = await context.state.marsPeriodService.grid(params);
      const updatedPeriod = result?.data?.records[0];
      context.dispatch("setMarsPeriod", updatedPeriod);
    } catch (e) {
      console.error('Can\'t update period', e);
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
